export default function HeroSection() {
  return (
    <section className="hero-bg min-h-screen flex items-center pt-20">
      <div className="w-full relative z-10">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="max-w-2xl">
            <a 
              href="https://lin.ee/MJ3LVM2" 
              target="_blank"
              rel="noopener noreferrer"
              className="bg-green-100 text-green-800 px-4 py-2 rounded-full inline-block mb-6 hover:bg-green-200 transition-all cursor-pointer hover:scale-105"
            >
              <span className="text-sm font-medium">🎁 今なら LINE 登録で特典プレゼント!</span>
            </a>
            <h1 className="text-4xl sm:text-5xl lg:text-6xl font-bold text-gray-900 mb-6 leading-tight">
              働き方も、時給も、<br />
              <span className="text-blue-500">妥協しない。</span><br />
              介護の派遣はトラストで。
            </h1>
            <p className="text-lg sm:text-xl text-gray-700 mb-8 leading-relaxed">
              ブランクがあっても大丈夫。週3日、1日6時間から始められる<br className="hidden sm:block" />
              あなたらしい働き方を、私たちが一緒に見つけます。
            </p>
            <div className="flex flex-col sm:flex-row gap-4">
              <a 
                href="https://lin.ee/MJ3LVM2" 
                target="_blank"
                rel="noopener noreferrer"
                className="line-btn-primary flex items-center justify-center space-x-3 text-base sm:text-lg font-medium whitespace-nowrap cursor-pointer"
              >
                <div className="w-6 h-6 flex items-center justify-center">
                  <i className="ri-line-fill text-xl"></i>
                </div>
                <span>公式LINEから問い合わせる</span>
              </a>
              <a 
                href="tel:052-887-6243" 
                className="bg-white text-primary border-2 border-primary px-6 sm:px-8 py-4 rounded-full hover:bg-primary hover:text-white transition-all flex items-center justify-center space-x-2 text-base sm:text-lg font-medium whitespace-nowrap cursor-pointer"
              >
                <div className="w-6 h-6 flex items-center justify-center">
                  <i className="ri-phone-line text-xl"></i>
                </div>
                <span>電話で問い合わせる</span>
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}